module.exports = __webpack_public_path__ + "static/media/maraca_novo.556b6cad.jpg";